export const ScheduledType = {
  Daily: 1,
  Weekly: 2,
  Custom: 3,
  Instantly: 4,
  Schedule: 5
}
